import { client } from "../utils/netlify";
import { useRouter } from "next/compat/router";
import { builderClient } from "../utils/builder";
import { reportError } from "@/helpers/errorHelper";
import { setCookie, getCookie, hasCookie } from "cookies-next";
import { generalConstants } from "@/utils/constants";
import crypto from "crypto";

/**
 * Create a new wishlist with unique Hash for a user or retrieve old one if it exists
 * @param {Object} request
 * @param {string} request.storeCustomerId - customerId of logged in customer (whose wishlist is to be retreived).
 */
export const getShopMetaData = async () => {
   try{
    let defaultCause = {};
    let resp = await client("get-shop-meta-data", {})
    resp = resp.data.shop.metafields.edges.map((data) => (
        JSON.parse(data.node.value)
        ));
        
    defaultCause = resp.filter((eachItems)=>{
        if(eachItems.site_default == 1){
            return true;
        }else{
            return false
        }
    })
    
    
    const storage = window.localStorage;
    storage.setItem("cause_list", JSON.stringify(resp));
    storage.setItem("default_cause", JSON.stringify(defaultCause[0].short_code));

    return {"causeList":resp,"defaultCause":defaultCause[0].short_code};
  }catch(error){
    console.error('Error in getShopMetaData : ',error)
    reportError('Error in getShopMetaData')
    reportError(error)
  }
};
/**
 * Get current page type the component is included in (home, editorial, PDP, etc)
 */
export const getCurrentPageType = async () => {
  const pageURL = window.location.pathname;
  //Fetch editorial urls
  const pages = await builderClient.getAll("page", {
    // We only need the URL field
    fields: "data.url",
    options: { noTargeting: true },
  });
  const editorialPages = pages.map((page) => `${page.data?.url}`);
  let pageType = "plp";
  if (pageURL == "/") {
    pageType = "home";
  } else if (editorialPages.includes(pageURL)) {
    pageType = "editorial";
  } else if (pageURL.includes("/products/")) {
    pageType = "pdp";
  }
  return pageType;
};

/**
 * Set current page type the component is included in cookie (home, editorial, PDP, etc)
 */
export const setCurrentPageTypeCookie = (type, data) => {
  setCookie(
    "currentPageType",
    {
      type: type,
      data: data,
    },
    // 2 minutes age
    { maxAge: 60 * 2 }
  );
};

/**
 * Get current page type the component is included from cookie (home, editorial, PDP, etc)
 */
export const getCurrentPageTypeCookie = () => {
  let value = {};
  if (hasCookie("currentPageType")) {
    value = JSON.parse(getCookie("currentPageType"));
  }
  return value;
};

export const removePLPFilterCookies = (pathnameRouter) => {
  sessionStorage.removeItem(`${pathnameRouter}~type`, '')
  sessionStorage.removeItem(`${pathnameRouter}~category`, '')
  sessionStorage.removeItem(`${pathnameRouter}~subcategory`, '')
  sessionStorage.removeItem(`${pathnameRouter}~Brand`, '')
  sessionStorage.removeItem(`${pathnameRouter}~Color`, '')
  sessionStorage.removeItem(`${pathnameRouter}~Material`, '')
  sessionStorage.removeItem(`${pathnameRouter}~Size`, '')
  sessionStorage.removeItem(`${pathnameRouter}~Heel Height`, '')
  sessionStorage.removeItem(`${pathnameRouter}~maxPrice`, '')
  sessionStorage.removeItem(`${pathnameRouter}~minPrice`, '')
  sessionStorage.removeItem(`${pathnameRouter}~Price`, '')
  sessionStorage.removeItem(`${pathnameRouter}~Sleeves`)
  sessionStorage.removeItem(`${pathnameRouter}~sort_by`)
  sessionStorage.removeItem(`${pathnameRouter}~Occasion`)
  return true;
};

export const checkIfEmail = (str) => {
  // Regular expression to check if string is email
  // const emailRegexExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/;
  // const domainRegexExp = /[\W\d]$/; /* check special char and number at the end of the string. To avoid invalid domain */
  return str.includes('@');
}

export const validatePassword=(str)=> {
  // Regular expression to check if string is password
  let paswd =
    /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*-])[a-zA-Z0-9!@#$%^&*-].{7,}$/;
  return str.match(paswd);
}

//redirect to a url when query param is present
export const redirectToUrl = (routerQuery) => {
  const redirectUrlPresent = routerQuery ? true:false;
      if(redirectUrlPresent){
        const redirectUrl = routerQuery;
        window.location.assign(redirectUrl);
      }
}

//remove target="_blank" element attribute from links
export const removeTargetAttr = () => {
  //To select all anchor tags with target attribute 
  const allLinksWithTarget = [...document.querySelectorAll('a[target="_blank"]')]
  //filter if target attribite is required in link
  .filter((allLinksWithTarget) => !allLinksWithTarget.matches('.social-icon'));
  //remove target attribute from anchor tags
  allLinksWithTarget.forEach(link => link.removeAttribute('target'));
}

//create chunks from array
export const chunkArrayInGroups=(arr, size)=>{
  const result=[]
  let temp=[]
  for(let a= 0;a<arr.length;a ++) {
    temp.push(arr[a])
    if(a%size===size-1) {
      result.push(temp)
      temp=[]
    }
  }
  if(temp.length>0)result.push(temp)  
  return result
}

//  function that renames the olivela_cost to oc in PDP pages
export const renameOlivelaCostToOC = (productDetails) => {
  if(!productDetails) {
    return false;
  }
  for (const edge of productDetails.variants.edges) {
    const node = edge.node;
    if (node.olivela_cost) {
      // Create a new property with the desired key "oc" and assign the value
      node.oc = node.olivela_cost;
      node.oc.key="oc"

      // Delete the old property with the key "olivela_cost"
      delete node.olivela_cost;
    }
  }
  return productDetails;
}
//checks if the data passed to the function is a json object or not
export const isValidJSON = (str)=>{
  try {
    JSON.parse(str);
  } catch (e) {
      return false;
  }
  return true;
}

//type takes either "encrypt" or "decrypt". Default value for type is encrypt
export const encryptOrDecrypt = (data, type = "encrypt") => {
  try {
    const algorithm = "aes-256-cbc";
    // generate 16 bytes of random data
    const initVector = "Kszfgv5i7txa3its";
  
    if (type === "decrypt") {
      // decipher function
      const decipher = crypto.createDecipheriv(
        algorithm,
        process.env.SECRET_KEY_CRYPTO,
        initVector
      );
      let decryptedData = decipher.update(data, "hex", "utf-8");
      decryptedData += decipher.final("utf-8");
      return JSON.parse(decryptedData);
    }
  
    // cipher function
    const cipher = crypto.createCipheriv(
      algorithm,
      process.env.SECRET_KEY_CRYPTO,
      initVector
    );
    let encryptedData = cipher.update(JSON.stringify(data), "utf-8", "hex");
    encryptedData += cipher.final("hex");
  
    return encryptedData;
  } catch (error) {
    console.log(error)
  }
};

export const isPWAVisits = () => {
  if (typeof window!="undefined" && (window.matchMedia("(display-mode: standalone)").matches || window.navigator?.userAgent?.includes("PWAShell"))) {
    if (!localStorage.getItem("firstVisit")) {
      // Code to run on the first visit
      console.log("First time opening the PWA");
      // window.alert("First time opening the PWA");
      // Set a flag in local storage to indicate the PWA has been visited
      localStorage.setItem("firstVisit", true);
      return true; // Return true for the first visit
    } else {
      // Code to run on subsequent visits
      console.log("Returning visit to the PWA");
      localStorage.setItem("firstVisit", false);
      // window.alert("Returning visit to the PWA");
      return false; // Return false for subsequent visits
    }
  }
  return false; // Return false if not in PWA mode
 };

 export const isPWA = () => {
  if (typeof window !== "undefined") {
    return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true || window.navigator?.userAgent?.includes("PWAShell");
  }
  return false; // Handle the case when window is undefined
 };


export const getProductStatusByID = async (id) => {
  try {
    const regex = /(\d+)$/;
    // fetching only id from the shopify product
    const match = id.match(regex);

    if (match) {
      id = match[1];
    }
    const resp = await client("get-product-status-by-id", { id });
    return resp;
  } catch (error) {
    reportError("Error in function getProductStatusById")
    reportError(error)
  }
};

export const adjustAccessibilityForApp = () => {
  if (typeof document !== undefined) {
    const interval = setInterval(() => {
      if (document.getElementById("INDmenu-btn")) {
        document.getElementById("INDmenu-btn").style.display = "none";
      }
      if (document.getElementById("INDmenu")) {
        document.getElementById("INDmenu").style.marginTop = "4.5rem";
        document.getElementById("INDmenu").style.height = "calc(100% - 4.5rem)";
      }
      if (document.getElementById("INDmenuBody")) {
        document.getElementById("INDmenuBody").style.height =
          "calc(585px - 4.5rem)";
      }
      if (document.getElementById("INDmenu-btn")) {
        clearInterval(interval);
      }
    }, 100);
  }
};

export const getKlaviyoProfile = async (external_id,field) => {
  try{
   let resp = await client("get-klaviyo-profile", {"email" : external_id, "field" : field})
   return resp;
 }catch(error){
   reportError('Error in getKlaviyoProfile')
   reportError(error)
   return '';
 }
};

export const kustomerJWT = async function (email) {
  return new Promise((resolve, reject) => {
    try {
      client("kustomer-jwt-token", { email: email })
      .then((response) => {
        resolve(response.token) ;
      });
    } catch (error) {
      reportError('Error in kustomerJWT')
      reportError(error)
      // reject(error);
    }
  })
};


export const getEngraveFonts = async () => {
  try{
   let resp = await client("get-engrave-fonts")
   return resp;
 }catch(error){
   reportError('Error in getEngraveFonts')
   reportError(error)
   return {};
 }
};

//add ellipses to a string
export const add3Dots = (string, limit) => {
  let dots = "...";
  if (string && string.length > limit) {
    string = string.substring(0, limit) + dots;
  }

  return string;
}

// Utility function to update tabIndex based on slide state
const updateTabIndex = (slide, tabIndexValue) => {
  const manualRowDiv = slide.querySelector("a.exclude-pwa-loader");
  const quickbuyRowDiv = slide.querySelector("div.quick_buy");
  const wishlistDiv = slide.querySelector("div.wish-wrapper");
 
  if (manualRowDiv) manualRowDiv.tabIndex = tabIndexValue;
  if (quickbuyRowDiv) quickbuyRowDiv.tabIndex = tabIndexValue;
  if (wishlistDiv) wishlistDiv.tabIndex = tabIndexValue;
};

const sliderTraversal = (sliderRef, innerSlider, flag = false) => {
  const activeElements = innerSlider.list.querySelectorAll(".slick-active");
  const lastActiveElement = activeElements[activeElements.length - 1]?.querySelector("a");
  const allElements = innerSlider.list.querySelectorAll(".slick-slide:not(.slick-cloned)");
  const lastElement = allElements[allElements.length - 1]?.querySelector("a");

  if (flag) {
    const handleKeyDown = (event) => {
      try {
        if (event?.key === 'Tab' && document.activeElement === lastActiveElement) {
            if(!(document.activeElement === lastElement))
            {
              event.preventDefault();
              sliderRef?.current?.slickNext();
              const newActiveElements = innerSlider.list.querySelectorAll(".slick-active a");
              const newFirstElement = newActiveElements[0];
              if (newFirstElement) newFirstElement.focus(); 
            }        
        }
      } catch (error) {
        reportError(error); // Log error using reportError function
        reportError("error at handle keydown event general helper activelement check"); 
      }
    };
  
    innerSlider.list.addEventListener('keydown', handleKeyDown);
    // Clean up event listener when component unmounts or sliderRef changes
    return () => innerSlider.list.removeEventListener('keydown', handleKeyDown);

  } else {
    // Handle non-feature slider by advancing slide on last element focus
    if (document.activeElement === lastActiveElement) {
      sliderRef.current.slickNext();
    }
  }
};
 
// Main function for selecting slider elements
export const selectSliderElements = (sliderRef, feature_sliderRef) => {
  const processSlides = (sliderRef, isFeatureSlider = false) => {
    if (!sliderRef?.current) return;
 
    const innerSlider = sliderRef.current.innerSlider;
    if (!innerSlider) return;
 
    const slideElements=innerSlider.list.querySelectorAll(".slick-slide");
 
    slideElements.forEach((slide) => {
      const isActive = slide.classList.contains("slick-active");
      const isCloned = slide.classList.contains("slick-cloned");
      const tabIndexValue = isActive && !isCloned ? 0 : -1;
 
      // Set tabIndex based on active state
      updateTabIndex(slide, tabIndexValue);
 
      // Handle feature-carousel logic
      if (isFeatureSlider) {
        const featureRowDiv = slide.querySelector("a");
        if (featureRowDiv) featureRowDiv.tabIndex = tabIndexValue;
      }
    });
 
    // conditional functional call to invoke traversal logic
    if (isFeatureSlider) 
      sliderTraversal(sliderRef,innerSlider,true);
    else 
      sliderTraversal(sliderRef,innerSlider);
  };
 
  // Process regular and feature slider elements
  processSlides(sliderRef);
  processSlides(feature_sliderRef, true);
};
 
// Generic function for other carousels
export const selectSliderElementsGen = (sliderRef, flag = false) => {
  if (!sliderRef?.current) return;
 
  const innerSlider = sliderRef.current.innerSlider;
  if (!innerSlider) return;
 
  const slideElements=innerSlider.list.querySelectorAll(".slick-slide");
 
  slideElements.forEach((slide) => {
    const isActive = slide.classList.contains("slick-active");
    const isCloned = slide.classList.contains("slick-cloned");
    const tabIndexValue = isActive && !isCloned ? 0 : -1;
 
    const sliderRow = slide.querySelector("a");
    const cta = slide.querySelector("a.cta");
 
    if (sliderRow) sliderRow.tabIndex = tabIndexValue;
    if (cta) cta.tabIndex = -1; // CTA should always be non-focusable unless active
  });

  const allElements=innerSlider.list.querySelectorAll(".slick-slide:not(.slick-cloned)");
  const lastElement=allElements[allElements.length-1]?.querySelector("a");

  //Handle testimonial-carousel logic and global banner logic
  if (flag) {
    const handleKeyDown = (event) => {
      try {
        if (event?.key === 'Tab'){
          const activeElements = innerSlider.list.querySelectorAll(".slick-active a");
          const lastActiveElement = activeElements[0];

          if(document.activeElement === lastActiveElement && !(document.activeElement === lastElement)){
            event.preventDefault();
            sliderRef.current.slickNext();
            const newActiveSlides = innerSlider.list.querySelectorAll(".slick-active a");
            const nextElement=newActiveSlides[0];

            if(nextElement) nextElement.focus();
          }
        }
      } catch (error) {
        reportError(error); // Log error using reportError function
        reportError("eror at handle keydown event for tab general helper");
      }
    };
  
    innerSlider.list.addEventListener('keydown', handleKeyDown);
    // Clean up event listener when component unmounts or sliderRef changes
    return () => innerSlider.list.removeEventListener('keydown', handleKeyDown);

  }
  else 
    sliderTraversal(sliderRef,innerSlider,true);
};
 
/**
 * Get search text from session storage
 * @returns {string|null} The search text if it exists, otherwise null
 */
export const getOliSearchText = () => {
  if (typeof window !== "undefined") {
    return sessionStorage.getItem("searchText");
  }
  return null;
};

export const isBeautyOrJewelryPDP = (category) => {
  //Categories to be excluded
  const excludedCategoriesForColors = ["categories.lvl0:Beauty","categories.lvl0:Jewelry & watches"];
  //Condition to check if catgory contains excludedCategories for colors
  const isExcluded = excludedCategoriesForColors.some((excludedCategory) =>
    category.includes(excludedCategory)
  );
  return isExcluded;
}

export const getBaseColor = (baseColor) => {
  if (!baseColor) return null ;
  // If any value in the comma-separated list contains "multicolor", return "Multicolor"
  if (baseColor.toLowerCase().includes("multicolor")) return "Multicolor";
  // Otherwise, return the first value before the comma or single value
  return baseColor.split(',')[0].trim();
};
